import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_GET_MSG_COUNT}`;

export const getMessageCount = () => axios.get(API_PATH);
